export const contactJson = {
  id: "",
  campaign_id: "",
  Email_Address: "",
  adset_id: "",
  ad_id: "",
  First_Name: "",
  Last_Name: "",
  Phone_No: "",
  City: "",
  Country_Id: "0",
  Create_By: "0",
  Last_Activity_By: "0",
  Active_Flag: "1",
  pageId: "",
  createdtime: "",
  leadgen_id: "",
  ad_id: "",
  adset_id: "",
  form_id: "",
  Qualifies: "0",
  Educational_Status: "0",
  Year_Of_Completion: "0",
  Category_Of_Study: "0",
  Interested_Country: "0",
  Interested_Field_Of_Study: "0",
  Interested_Level_Of_Study: "0",
  English_Test_Attempted: "0",
  English_Test_Score: "",
  Team_Id: "0",
  Contact_Platform: "",
  Reason_not_Qualify: "0",
  Preferred_Intake: "0",
  Profile_Status: "0",
  Month_Id: "0",
  Academic_Percentage: "0",
  Intake_Year: "0",
  Email_Address1: "",
  Email_Address2: "",
  Phone_No1: "",
  Phone_No2: "",
  Hubspot_Contact_Id: "",
  Comments: "",
  Contact_priority: "0",
  Lead_Source: "0",
  referral_type: "0",
  full_name: "",
  Assigned_User_Id: "0",
  Referral_User_Id: "0",
  Referral_SubAgent_Id: "0",
  Referral_Contact_Id: "0",
  Gender: "0",
  Date_Of_Birth: "",
  Marital_Status: "0",
  Contact_Rating: "0",
  How_you_heard_About_Us: "0",
  Branch: "0",
  Enquiry_For: "0",
  Interested_Country2: "0",
  Financial_Source: "0",
  Counsellor_Meeting: "0",
  Meeting_Date: "",
  Ielts_Paid: "0",
  Contact_Owner_II: "0",
  State: "",
  Passport_number: "",
  Grading_System: "0",
  EmRelation: "0",
  EmName: "",
  EmPhone_Number: "",
  EmEmail_Address: "",
  OSHC_Type: "0",
  Previous_Visa_Refusal: "0",
  Visa_Refusal_Reason: "",
  Vaccination_Status: "0",
  Activity: "",
  Activity_Des: "",
  notificationCode: "",
  Contact_Owner: "",
  visa_expiry_date: "",
};

export const CountryList = [
  {
    Id: 2,
    I_Country: "AUSTRALIA",
    Priority: 1,
  },
  {
    Id: 3,
    I_Country: "NEW ZEALAND",
    Priority: 2,
  },

  {
    Id: 4,
    I_Country: "UK",
    Priority: 3,
  },

  {
    Id: 5,
    I_Country: "IRELAND",
    Priority: 4,
  },

  {
    Id: 6,
    I_Country: "CANADA",
    Priority: 5,
  },
  {
    Id: 11,
    I_Country: "USA",
    Priority: 10,
  },
  {
    Id: 13,
    I_Country: "DUBAI",
    Priority: 12,
  },
  {
    Id: 15,
    I_Country: "SINGAPORE",
    Priority: 14,
  },
  {
    Id: 9,
    I_Country: "GERMANY",
    Priority: 8,
  },

  {
    Id: 7,
    I_Country: "FRANCE",
    Priority: 6,
  },
  {
    Id: 8,
    I_Country: "SPAIN",
    Priority: 7,
  },

  {
    Id: 16,
    I_Country: "SWITZERLAND",
    Priority: 15,
  },

  {
    Id: 17,
    I_Country: "MALTA",
    Priority: 16,
  },
  {
    Id: 10,
    I_Country: "ITALY",
    Priority: 9,
  },
  {
    Id: 12,
    I_Country: "OTHERS",
    Priority: 11,
  },
];
